(function() {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('scripts-types', {
            parent: 'entity',
            url: '/scripts-types',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.scriptsTypes.home.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/scripts-types/scripts-types.html',
                    controller: 'ScriptsTypesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('scriptsTypes');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('scripts-types-detail', {
            parent: 'scripts-types',
            url: '/scripts-types/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.scriptsTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/scripts-types/scripts-types-detail.html',
                    controller: 'ScriptsTypesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('scriptsTypes');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ScriptsTypes', function($stateParams, ScriptsTypes) {
                    return ScriptsTypes.get({id : $stateParams.id});
                }]
            }
        })
        .state('scripts-types-new', {
            parent: 'scripts-types',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.scriptsTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/scripts-types/scripts-types-dialog.html',
                    controller: 'ScriptsTypesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('scriptsTypes');
                    return $translate.refresh();
                }],
                entity: function () {
                    return {
                        deviceTypeName: null,
                        deviceTypeDescription: null,
                        isActive: false,
                        isVisibile: false,
                        id: null
                    };
                }
            }
        })
        .state('scripts-types-edit', {
            parent: 'scripts-types',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'jotApp.scriptsTypes.detail.title'
            },
            views: {
                'content@main': {
                    templateUrl: 'app/entities/scripts-types/scripts-types-dialog.html',
                    controller: 'ScriptsTypesDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('scriptsTypes');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ScriptsTypes', function($stateParams, ScriptsTypes) {
                    return ScriptsTypes.get({id : $stateParams.id});
                }]
            }
        })
        .state('scripts-types.delete', {
            parent: 'scripts-types',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/scripts-types/scripts-types-delete-dialog.html',
                    controller: 'ScriptsTypesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ScriptsTypes', function(ScriptsTypes) {
                            return ScriptsTypes.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('scripts-types', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
